module.exports = __webpack_public_path__ + "img/PTSans-Caption.774eb68f.svg";